import React, { useEffect, useRef, useState } from 'react';
import { useSiteSettings } from '../../lib/api/settings';
import { unlockGate } from '../../lib/api/gate';
import { NETWORKS } from '../../lib/networks';
import { applySeo } from '../../lib/seo';
import Logo from '../../assets/img/logo/sanasa-logo-white.png';

// The page visitors see while the gate is on. Staff use the small "Staff preview" link at the bottom to enter the password.
const ComingSoon = ({ onUnlocked }) => {
  const { contact } = useSiteSettings();
  const [open, setOpen] = useState(false);
  const [password, setPassword] = useState('');
  const [state, setState] = useState({ status: 'idle', message: '' });
  const input = useRef(null);
  const social = NETWORKS.filter(([key]) => contact[key]);

  // Keep this page out of search engines.
  useEffect(() => {
    applySeo({ title: 'SANASA Campus - Coming soon', description: 'The new SANASA Campus website is coming soon.', noindex: true });
  }, []);

  useEffect(() => {
    if (open && input.current) input.current.focus();
  }, [open]);

  const close = () => {
    setOpen(false);
    setPassword('');
    setState({ status: 'idle', message: '' });
  };

  const submit = async (e) => {
    e.preventDefault();
    if (!password || state.status === 'sending') return;
    setState({ status: 'sending', message: '' });
    try {
      await unlockGate(password);
      onUnlocked();
    } catch (err) {
      setState({ status: 'error', message: err.message });
      if (input.current) input.current.select();
    }
  };

  return (
    <main className="sc-soon">
      <div className="sc-soon__card">
        <img className="sc-soon__logo" src={Logo} alt="SANASA Campus Ltd." width="240" />
        <span className="sc-soon__tag">Coming soon</span>
        <h1>Our new website is on its way</h1>
        <p>
          SANASA Campus Ltd. in Kegalle is getting a new home on the web, with all our degrees, diplomas and short courses in one place.
          Please check back soon.
        </p>

        <ul className="sc-soon__contact">
          <li>
            <a href={contact.generalPhoneHref}>
              <i className="fal fa-phone-alt"></i>
              {contact.generalPhone}
            </a>
          </li>
          <li>
            <a href={`mailto:${contact.email}`}>
              <i className="fal fa-envelope"></i>
              {contact.email}
            </a>
          </li>
        </ul>

        {social.length > 0 && (
          <div className="sc-soon__social">
            {social.map(([key, label, icon]) => (
              <a key={key} href={contact[key]} target="_blank" rel="noreferrer" aria-label={label}>
                <i className={icon}></i>
              </a>
            ))}
          </div>
        )}
      </div>

      <div className="sc-soon__foot">
        {open ? (
          <form className="sc-soon__unlock" onSubmit={submit} onKeyDown={(e) => e.key === 'Escape' && close()}>
            <label htmlFor="preview-password">Preview password</label>
            <div className="sc-soon__unlock-row">
              <input
                id="preview-password"
                ref={input}
                type="password"
                autoComplete="current-password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                maxLength={200}
              />
              <button type="submit" disabled={!password || state.status === 'sending'}>
                {state.status === 'sending' ? 'Checking...' : 'Enter'}
              </button>
              <button type="button" className="is-ghost" onClick={close}>
                Cancel
              </button>
            </div>
            <p className="sc-soon__error" role="alert">
              {state.status === 'error' ? state.message : ''}
            </p>
          </form>
        ) : (
          <>
            <span>&copy; SANASA Campus Ltd.</span>
            <button type="button" className="sc-soon__staff" onClick={() => setOpen(true)}>
              Staff preview
            </button>
          </>
        )}
      </div>
    </main>
  );
};

export default ComingSoon;
